@if (showAccessAlert) {
  <app-alert
    [title]="accessAlertTitle"
    [message]="accessAlertMessage"
    [type]="accessAlertType"
    [duration]="4200"
    [token]="accessAlertToken"
  ></app-alert>
}

@if (isOpen && isMobile) {
  <div
    class="fixed inset-0 bg-[var(--color-gray-200)]/70 dark:bg-[var(--color-dark-bg-primary)]/70 z-40"
    (click)="toggleSidebar()"
    aria-hidden="true"
  ></div>
}

<!-- Menú izquierdo collapse -->

<div
  class="fixed inset-y-0 text-deploy-black-60 border-r border-[var(--color-gray-100)] bg-[#DCEAFF] z-50 shadow-sm flex flex-col h-full dark:bg-[var(--color-dark-bg-secondary)] dark:border-[var(--color-gray-900)] overflow-y-auto overflow-x-hidden profile-sidebar"
  [ngClass]="{
    '-translate-x-full': !isOpen,
    'translate-x-0': isOpen,
    'left-14': !isMobile && !isMenuExpanded,
    'left-64': !isMobile && isMenuExpanded,
    'left-0': isMobile,
    'pt-16': isMobile,
    'w-72': isSidebarExpandedView,
    'w-16 profile-sidebar--collapsed': !isMobile && !isProfileSidebarExpanded,
  }"
>
  @if (isMobile) {
  <div class="absolute top-4 right-4 z-10">
    <button
      type="button"
      class="w-9 h-9 rounded-xl bg-white/85 dark:bg-[var(--color-dark-bg-primary)]/80 border border-[var(--color-gray-200)] dark:border-[var(--color-dark-bg-tertiary)] flex items-center justify-center text-[var(--color-text-300)] dark:text-[var(--color-white)] cursor-pointer"
      (click)="toggleSidebar()"
      aria-label="Cerrar panel lateral"
    >
      <fa-icon [icon]="faChevronLeft" class="text-sm"></fa-icon>
    </button>
  </div>
  }

  @if (!isMobile) {
  <button
    type="button"
    class="absolute right-4 top-4 w-5 h-5 flex items-center justify-center rounded cursor-pointer hover:bg-[var(--color-brand-100)] dark:hover:bg-[var(--color-white)]/10 p-3 group text-[var(--color-gray-600)] dark:text-[var(--color-gray-300)] transition-colors sidebar-collapse-btn"
    (click)="toggleProfileSidebar()"
    aria-label="Plegar menú secundario"
  >
    <fa-icon
      [icon]="isProfileSidebarExpanded ? faChevronLeft : faChevronRight"
      class="text-base group-hover:text-[var(--color-brand-400)]"
    ></fa-icon>
  </button>
  }

  <div class="flex-1 p-6 flex flex-col justify-start sidebar-content">
    <div class="text-center my-6 sidebar-header">
      <div class="relative inline-block company-image-dropdown-container">
        @if (!isSettingsRoute && companyProfileImageUrl) {
          <div
            class="w-26 h-26 mx-auto mb-4 rounded-full overflow-hidden bg-[var(--color-gray-200)] dark:bg-[var(--color-gray-700)]"
          >
            <img
              [src]="companyProfileImageUrl"
              [alt]="companyName"
              class="w-full h-full object-cover"
              (error)="onImageError()"
            />
          </div>
        } @else if (!isSettingsRoute) {
          <div
            class="w-26 h-26 mx-auto mb-4 bg-[var(--color-brand-400)] rounded-full flex items-center justify-center"
          >
            <fa-icon
              [icon]="faBuildings"
              class="text-[var(--color-white)] text-2xl"
            ></fa-icon>
          </div>
        }
        @if (isSettingsRoute) {
          <!-- Imagen de empresa editable en modo settings -->
          <div
            class="relative group cursor-pointer"
            (click)="toggleCompanyImageDropdown($event)"
          >
            @if (companyProfileImageUrl) {
              <div
                class="w-20 h-20 mx-auto mb-4 rounded-full overflow-hidden bg-[var(--color-gray-200)] dark:bg-[var(--color-gray-700)]"
              >
                <img
                  [src]="companyProfileImageUrl"
                  [alt]="companyName"
                  class="w-full h-full object-cover"
                  (error)="onImageError()"
                />
              </div>
            } @else {
              <div
                class="w-20 h-20 mx-auto mb-4 bg-[var(--color-brand-400)] rounded-full flex items-center justify-center"
              >
                <fa-icon
                  [icon]="faBuildings"
                  class="text-[var(--color-white)] text-2xl"
                ></fa-icon>
              </div>
            }
            <!-- Overlay con icono de cámara al hacer hover -->
            <div
              class="absolute inset-0 w-20 h-20 mx-auto rounded-full bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200"
            >
              <fa-icon [icon]="faCamera" class="text-white text-lg"></fa-icon>
            </div>
          </div>

          <!-- Dropdown de opciones de imagen -->
          @if (isCompanyImageDropdownOpen) {
            <div
              class="absolute left-1/2 -translate-x-1/2 mt-0 w-44 bg-white dark:bg-[var(--color-dark-bg-primary)] border border-[var(--color-gray-200)] dark:border-[var(--color-gray-700)] rounded-lg shadow-lg z-[60] overflow-hidden"
            >
              <button
                (click)="onUploadCompanyImageClick()"
                class="w-full flex items-center gap-2 px-3 py-2.5 text-sm text-[var(--color-gray-700)] dark:text-[var(--color-gray-300)] hover:bg-[var(--color-gray-100)] dark:hover:bg-[var(--color-white)]/10 transition-colors cursor-pointer"
              >
                <fa-icon
                  [icon]="faArrowUpFromBracket"
                  class="text-xs"
                ></fa-icon>
                <span>Subir imagen</span>
              </button>
              @if (companyProfileImageUrl) {
                <button
                  (click)="onDeleteCompanyImageClick()"
                  class="w-full flex items-center gap-2 px-3 py-2.5 text-sm text-[var(--color-error-500)] hover:bg-[var(--color-gray-100)] dark:hover:bg-[var(--color-white)]/10 transition-colors cursor-pointer"
                >
                  <fa-icon [icon]="faTrash" class="text-xs"></fa-icon>
                  <span>Eliminar imagen</span>
                </button>
              }
            </div>
          }
        }
      </div>
      @if (!isSettingsRoute) {
        <h2
          class="text-xl font-semibold text-[var(--color-gray-800)] dark:text-[var(--color-white)] mb-1"
        >
          {{ companyName || "Empresa" }}
        </h2>
      }
      @if (isSettingsRoute) {
        <h2
          class="text-xl font-semibold text-[var(--color-gray-800)] dark:text-[var(--color-white)] mb-1"
        >
          {{ companyName || "Empresa" }}
        </h2>
      }
      <!--<p class="text-sm text-[var(--color-gray-600)] dark:text-[var(--color-gray-400)]">{{ companyId || 'NIF no disponible' }}</p> -->
    </div>

    <!-- Settings menu - Only visible in settings route -->
    @if (isSettingsRoute && (!isBackofficeMode || isSettingsRoute)) {
      <div class="sidebar-menu">
        @if (isLicensePendingActivationMode) {
          <ul class="space-y-2">
            <li>
              <app-sidebar-navigation-group
                [group]="settingsFallbackProfileGroup"
                [variant]="isSidebarExpandedView ? 'profile-settings' : 'profile-collapsed'"
                [currentSection]="activeSettingsSection"
                [separatorClass]="''"
                [titleClass]="
                  isSidebarExpandedView
                    ? 'text-sm text-[var(--color-gray-600)] dark:text-[var(--color-gray-400)] tracking-wider mb-2 px-3 sidebar-section-title'
                    : 'hidden'
                "
                [itemsClass]="'space-y-2'"
                (itemSelected)="onProfileNavigationItemClick($any($event))"
              ></app-sidebar-navigation-group>
            </li>
          </ul>
        } @else {
        <ul class="space-y-2">
          @for (group of settingsGroups; track group.id) {
            <li>
              <app-sidebar-navigation-group
                [group]="group"
                [variant]="isSidebarExpandedView ? 'profile-settings' : 'profile-collapsed'"
                [currentSection]="activeSettingsSection"
                [separatorClass]="
                  isSidebarExpandedView
                    ? 'h-px bg-[var(--color-gray-300)]/30 dark:bg-[var(--color-white)]/10 my-4'
                    : 'hidden'
                "
                [titleClass]="
                  isSidebarExpandedView
                    ? 'text-sm text-[var(--color-gray-600)] dark:text-[var(--color-gray-400)] tracking-wider mb-2 px-3 sidebar-section-title'
                    : 'hidden'
                "
                [itemsClass]="'space-y-2'"
                (itemSelected)="onSettingsNavigationItemClick($any($event))"
              ></app-sidebar-navigation-group>
            </li>
          }
        </ul>
        }
      </div>
    }

    <!-- Profile menu - Only visible NOT in settings route -->
    @if (
      (activeSection === "profile" ||
        activeSection === "company" ||
        activeSection === "users" ||
        activeSection === "payments") &&
      !isBackofficeMode &&
      !isSettingsRoute
    ) {
      <div class="sidebar-menu">
        <ul class="space-y-2">
          <li>
            <app-sidebar-navigation-group
              [group]="profileAdminGroup"
              [variant]="isSidebarExpandedView ? 'profile-sm' : 'profile-collapsed'"
              [currentSection]="activeSection"
              [separatorClass]="''"
              [titleClass]="
                isSidebarExpandedView
                  ? 'text-sm text-[var(--color-gray-600)] dark:text-[var(--color-gray-400)] tracking-wider my-4 sidebar-section-title'
                  : 'hidden'
              "
              [itemsClass]="'space-y-2'"
              (itemSelected)="onProfileNavigationItemClick($any($event))"
            ></app-sidebar-navigation-group>
          </li>
        </ul>
      </div>
    }

    @if (
      activeSection !== "profile" &&
      activeSection !== "company" &&
      activeSection !== "users" &&
      activeSection !== "payments" &&
      !isSettingsRoute
    ) {
      <div
        class="sidebar-menu"
        [class.mt-6]="isSidebarExpandedView"
      >
        @if (isSidebarExpandedView) {
          <h3
            class="text-sm text-[var(--color-gray-600)] dark:text-[var(--color-gray-400)] tracking-wider mb-4 sidebar-section-title"
          >
            {{ profileUserGroup.title }}
          </h3>
        }
        <ul class="space-y-2">
          <li>
            <app-sidebar-navigation-group
              [group]="profileUserGroup"
              [variant]="isSidebarExpandedView ? 'profile-base' : 'profile-collapsed'"
              [currentSection]="activeSection"
              [separatorClass]="''"
              [titleClass]="''"
              [itemsClass]="'space-y-2'"
              (itemSelected)="onProfileNavigationItemClick($any($event))"
            ></app-sidebar-navigation-group>
          </li>
        </ul>
      </div>
    }
  </div>
</div>

<!-- Logout Confirmation Modal -->
@if (showLogoutConfirmation) {
  <div
    class="fixed inset-0 bg-[var(--color-gray-900)]/30 flex items-center justify-center z-[9999]"
    (click)="cancelLogout()"
  >
    <div
      class="bg-[var(--color-white)] dark:bg-[var(--color-dark-bg-secondary)] rounded-xl max-w-md w-full m-4 shadow-xl"
      (click)="$event.stopPropagation()"
    >
      <div
        class="px-4 pb-4 pt-5 sm:p-6 flex items-center justify-between border-b border-[var(--color-black)]/10 dark:border-[var(--color-white)]/10"
      >
        <h3
          class="text-lg font-medium text-[var(--color-black)] dark:text-[var(--color-white)]"
        >
          ¿Estás seguro?
        </h3>
      </div>
      <div class="grow overflow-y-auto p-4 sm:p-6">
        <p
          class="text-sm text-[var(--color-gray-600)] dark:text-[var(--color-gray-300)]"
        >
          ¿Deseas cerrar tu sesión?
        </p>
      </div>
      <div
        class="flex gap-3 justify-end px-4 pb-4 sm:px-6 sm:pb-6 border-t border-[var(--color-black)]/10 dark:border-[var(--color-white)]/10 pt-4"
      >
        <button
          class="px-4 py-2 font-medium h-[38px] hover:bg-[var(--color-gray-100)] rounded-full border border-[var(--color-gray-300)] text-sm cursor-pointer dark:border-[var(--color-white)]/15 dark:hover:bg-[var(--color-white)]/10 dark:text-[var(--color-white)]"
          (click)="cancelLogout()"
        >
          Cancelar
        </button>
        <button
          class="px-4 py-2 font-medium h-[38px] bg-[var(--color-error-500)] border-2 border-transparent hover:bg-transparent hover:border-[var(--color-error-500)] hover:text-[var(--color-error-500)] text-[var(--color-white)] rounded-full text-sm cursor-pointer transition-all duration-200"
          (click)="confirmLogout()"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  </div>
}
